import { render, staticRenderFns } from "./ChangeLeaders.vue?vue&type=template&id=422a5198&"
import script from "./ChangeLeaders.vue?vue&type=script&lang=js&"
export * from "./ChangeLeaders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports